import type { RootState } from 'store';

export const wishListAllInfoSelector = (state: RootState) => state.customer.customerWishList;
export const wishListItemsSelector = (state: RootState) =>
  state.customer.customerWishList.wishListItems;
export const wishListTotalProductSelector = (state: RootState) =>
  state.customer.customerWishList.totalWishListProducts;
export const wishListLoadingSelector = (state: RootState) =>
  state.customer.customerWishList.loading;
